<template>
   <div id="app">
      <div class="transition-wrapper">
         <span class="fader one"></span>
         <span class="fader two"></span>
         <span class="fader three"></span>
      </div>
      <CookiePopup v-if="!isPersonInfoPage" />
      <!-- <ApplicationForm v-if="ApplicationForm" /> -->
      <PdfContractForm :page-count="pdfInfo ? pdfInfo.pageCount : 3" v-if="ApplicationForm" />

      <HeaderMenu v-if="!isPersonInfoPage" />
      <!-- Empty space for fixed header menu -->
      <div style="height: 100px !important" v-if="!isPersonInfoPage"></div>
      <!-- <nav><router-link to="/">Home</router-link></nav> -->

      <transition name="fade" mode="out-in">
         <router-view />
      </transition>
      <FooterMenu v-if="!isPersonInfoPage" />
   </div>
</template>

<script>
import { PDFDocument } from "pdf-lib";
import CookiePopup from "@/components/common/Cookie.vue";
import HeaderMenu from "@/components/structural/HeaderMenu.vue";
import FooterMenu from "@/components/structural/FooterMenu.vue";
// import ApplicationForm from "@/components/unitary/ApplicationForm.vue";
import PdfContractForm from "@/components/unitary/PdfContractForm.vue";
import router from "./router";
import gsap from "gsap";
// import SplashScreen from "@/components/unitary/SplashScreen.vue";

export default {
   components: {
      HeaderMenu,
      FooterMenu,
      // ApplicationForm,
      PdfContractForm,
      CookiePopup,
      // SplashScreen,
   },
   data() {
      return {
         pdfInfo: null,
      };
   },

   computed: {
      CookiePopup() {
         const self = this;
         self;
         return self.$store.state.cookieAllowance;
         // return false;
      },
      ApplicationForm() {
         const self = this;
         return self.$store.state.applicationForm;
      },
      PdfContractForm() {
         const self = this;
         return self.$store.state.showPdfForm;
      },
      isPersonInfoPage() {
         return this.$route.name === "person-info";
      },
   },
   created() {
      const self = this;
      self;
      router.beforeResolve((to, from, next) => {
         // console.log(`Before resolve:`);
         this.handlerPageAnimationOpen();
         // console.log(`Route to`, to);
         // console.log(`Route from`, from);

         setTimeout(() => {
            next();
         }, 1000);
         // self.handlerPageAnimationClose();
      });

      // this.$i18n.locale = "de";
   },
   mounted() {
      this.loadPDF();
   },
   methods: {
      loadPDF() {
         fetch("/agenturvertrag.pdf")
            .then((response) => response.arrayBuffer())
            .then((pdfBytes) => PDFDocument.load(pdfBytes))
            .then((pdfDoc) => {
               const form = pdfDoc.getForm();
               const fields = form.getFields();

               this.pdfInfo = {
                  pageCount: pdfDoc.getPageCount(),
                  title: pdfDoc.getTitle(),
                  formFields: fields.map((field) => ({
                     name: field.getName(),
                     type: field.constructor.name,
                     value: field.getValue && field.getValue(),
                  })),
               };
               console.log("PDF yüklendi:", this.pdfInfo);
               console.log("Form alanları:", this.pdfInfo.formFields);
            })
            .catch((error) => {
               console.log("Hata:", error);
            });
      },
      handlerPageAnimationOpen() {
         const self = this;
         const t = gsap.timeline();
         t.fromTo(
            ".fader",
            {
               opacity: 1,
               width: 0,
            },
            {
               opacity: 1,
               width: "100%",

               duration: 1,
               ease: "expo.inOut",
               stagger: {
                  each: 0.125,
                  ease: "power.out",
               },
               onStart() {
                  document.querySelector(".transition-wrapper").style.zIndex = "9999";
                  // gsap.set(this.targets(), { clearProps: "transform" });
               },
               onComplete() {
                  self.handlerPageAnimationClose();
                  // self.handlerPageAnimationOpen();

                  console.log("handlerPageAnimationOpen completed");
               },
            }
         );
      },
      handlerPageAnimationClose() {
         const t = gsap.timeline({ delay: 0.125 });
         t.to(".fader", {
            // opacity: 0,
            width: 0,
            duration: 1,
            ease: "expo.out",
            stagger: {
               each: 0.125,
               ease: "power.out",
            },
            onComplete() {
               document.querySelector(".transition-wrapper").style.zIndex = "-1";
               console.log("handlerPageAnimatioClose completed");
            },
         });
      },
   },
   watch: {
      "$store.state.applicationForm": {
         handler: function () {
            console.log("koko");
         },
      },
      "$store.state.cookieAllowance": {
         handler: function (value) {
            value;
         },
      },
   },
};
</script>

<style lang="scss">
body {
   // background-color: coral !important;
}
#app {
   margin: 0;
   width: 100vw;
}

.transition-wrapper {
   position: fixed;
   inset: 0 0 0 0;
   z-index: -1;
   // background: gray;
}
.fader {
   // opacity: 1;

   // height: 50px;
   // width: 100px;
   // position: fixed;
   // top: 0;
   // bottom: 0;
   // // z-index: -1;
   // z-index: 9999;
   // // clip-path: circle(50px at 0 100px);
   position: fixed;
   top: 0;
   bottom: 0;
   display: block;
   // width: 20px;
   height: 100%;
   &.one {
      background: #2268db;
   }
   &.two {
      background: #00c3ff;
   }
   &.three {
      background: #2dd5ff;
   }
   &.four {
      background: #94eaff;
   }
   &.three {
      background: #94eaff;
   }
}
</style>
